require("./bootstrap");

require("./libraries/Swup");
